<header class="header-bar">
  <div class="header-inner">
    <button type="button" class="brand-button" (click)="goHome()" aria-label="Go to jobs">
      <img src="/tops-logo-white.png" alt="TOPS Logo" />
      <span>TOPS Offline</span>
    </button>
    <div class="header-actions">
      @if (auth.account(); as account) {
        <span class="signed-in-user">{{ account.name || account.username }}</span>
      }
      <div class="network-status" [class.offline]="!isOnline" role="status" aria-live="polite" [attr.aria-label]="isOnline ? 'Application online' : 'Application offline'">
        <img class="network-icon" [src]="isOnline ? '/assets/icons/wifi-online.svg' : '/assets/icons/wifi-offline.svg'" [alt]="isOnline ? 'Online' : 'Offline'" />
        <span class="network-label">{{ isOnline ? 'Online' : 'Offline' }}</span>
      </div>
      <button type="button" class="icon-button bell-icon" (click)="showReleaseNotes()" title="What's new" aria-label="What's new"></button>
      <button hidden type="button" class="icon-button user-icon" (click)="showUserMenu()" title="Settings and app info" aria-label="Settings and app info"></button>
      <button hidden type="button" class="sign-out-button" (click)="signOut()">Sign out</button>
    </div>
  </div>
</header>
